module.exports = __webpack_public_path__ + "static/media/Expansion of dental arches15.63879fe2.png";